import './App.css';
import './About.css';
import { Col, Grid, Row, Typography, Button} from 'antd';
import { useEffect } from "react";
import ContactsBanner from './img/ContactsBanner.jpg';
import HomePageImgFamilyOneWeb from './img/HomePageImgFamilyOneWeb.png';
import HomePageImgEnterpriseOneWeb from './img/HomePageImgEnterpriseOneWeb.png';
import AmberFinLogo from './img/AmberFinLogo.png';
import { NavLink } from "react-router-dom";

const { Title, Text } = Typography;

function About() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
    return (
        <>
            <Row 
            className={'page-row'}
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto',
                textAlign: "center"
            }}>
                <Col span={24}>
                    <Title level={1}>We change the way you do IT</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>Amber IT helps you develop, infrastreucture, and QA smarter. Welcome to your new <br />favourite way to do all things IT.</Title>
                    <br />
                <NavLink className={"menu"} to={'/contacts'}>
                    <Button size="large" variant='solid' color="default" style={{marginBottom: 48}}>Contact us</Button>
                </NavLink>
           
                </Col>
            </Row>
            
            <Row 
            className={'page-row'}
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto'
            }}
            gutter={[0, 16]}>
                <Col
                    xs={0} md={8}
                    style={{padding: "16px 8px"}}
                >
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                        backgroundPosition: 'left',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: isMobile ? "300px" : "400px",
                        position: "relative",
                    }}>
                    </div>
                </Col>
                <Col xs={24} md={8} style={{padding: "0 8px"}}>
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: isMobile ? "300px" : "440px",
                        position: "relative",
                    }}>
                    </div>
                </Col>
                <Col 
                    xs={0} md={8} 
                    style={{padding: "16px 8px"}}
                >
                <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                        backgroundPosition: 'right',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: isMobile ? "300px" : "400px",
                        position: "relative",
                    }}>
                    </div>
                    </Col>
            </Row>
            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: '24px auto 96px auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>
                    <Title level={1} style={{marginTop: isMobile ? 48 : 128}}>This is our IT story</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>Our team brings together experienced architects, engineers, and consultants capable of delivering and
                        {" "}<br />operating complex, mission-critical systems</Title>
               
                </Col>
            </Row>

            <Row
                className={'page-row'}
                style={{
                    maxWidth: 1024,
                    margin: '0 auto'
                }}
            >
                <Col
                    xs={24} md={12}
                    style={{ textAlign: "left", paddingRight: isMobile ? 0 : 48, marginBottom: isMobile ? 24 : 0 }}
                    className={'cloud'}
                >
                    <Title level={1} style={{ marginBottom: 32, marginTop: isMobile ? 32 : 220 }}>Our mission</Title>
                    <Title level={4} style={{fontWeight: "normal" }}>Our mission is to help organizations leverage technology effectively and enable sustainable growth.</Title>
                </Col>
                <Col xs={24} md={12}>
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${ContactsBanner})`,
                        backgroundPosition: 'right',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: isMobile ? "360px" : "600px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Small & Medium Business</h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary"><img src={AmberFinLogo} style={{ maxWidth: '18px' }} alt={''} /></Text>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: isMobile ? '24px auto 48px auto' : '24px auto 124px auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>
                    <Title level={1} style={{marginTop: isMobile ? 48 : 128}}>Why us?</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>
                        We place strong emphasis on open-source technologies,
                        automation, DevOps<br /> practices, and cost transparency, enabling our clients to shift spending <br />from licenses to business outcomes.</Title>
                </Col>
            </Row>

            <Row
                className={'page-row'}
                style={{
                    maxWidth: 1024,
                    margin: '0 auto'
                }}
            >
                <Col xs={24} md={12}>
                
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgEnterpriseOneWeb})`,
                        backgroundPosition: 'left',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: isMobile ? "360px" : "600px",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Enterprise Business Solutions </h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary">
                                <img src={AmberFinLogo} style={{ maxWidth: '18px' }} alt={'Amber IT Logo'} />
                            </Text>
                        </div>
                    </div>
                </Col>
                <Col
                    xs={24} md={12}
                    style={{ textAlign: "left", paddingLeft: isMobile ? 0 : 48 }}
                    className={'cloud'}
                >
                    <Title level={1} style={{ marginBottom: 32, marginTop: isMobile ? 32 : 220 }}>What do we do</Title>
                    <Title level={4} style={{fontWeight: "normal" }}>We provide end-to-end IT services, ranging from strategic IT consulting and architecture design to
                        system development, modernization, cloud migration.</Title>
                </Col>
            </Row>
            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: isMobile ? '48px auto 0 auto' : '126px auto 0 auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>

                    <p>We act as a trusted technology partner, focused on long-term collaboration, clear accountability, and
                        delivering measurable value to our clients.</p>
                    <br />
                    <p style={{ textAlign: "right", fontSize: 10 }} className={"amber-title-color"}>
                        <strong>AMBER</strong>TECHNOLOGIES
                    </p>
                </Col>
            </Row>
        </>
    );
}

export default About;
